module.exports = __webpack_public_path__ + "7f95b2a88c58a5da20fcf2fb0d7c8aec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/spray-bw.png
// module id = 515
// module chunks = 0